// extracted by mini-css-extract-plugin
export default {"body":"TypeDistributionPanel_body__EU1pQ","noData":"TypeDistributionPanel_noData__bhGkA"};